import React from "react";
import NimbusLinkCard from "../../../ui-components/nimbus-link-card/nimbus-link-card";

const NimbusFinanceIndex = () => {
  return (
    <div className="flex flex-col justify-center h-full items-center text-center gap-2">
      <NimbusLinkCard
        title={"Stripe Customers"}
        to={"/nimbus/finance/stripe-pricing"}
        icon="fa-sack-dollar"
      />
    </div>
  );
};

export default NimbusFinanceIndex;
